import { z } from "zod";

export const LocalProducerSourceFieldSchema = z.enum(["artistName", "genre", "goals", "songText", "rightsAttestation", "aiDisclosureAcknowledged", "previousRelease", "rule_method", "rule_reference_inventory", "rule_scoring"]);
export const LocalProducerSourceManifestSchema = z.object({
  recordVersion: z.literal(1), producerVersion: z.literal("shadow-local-sources-v1"),
  runId: z.string().min(1).max(200), artistRecordId: z.string().min(1).max(200), projectId: z.string().min(1).max(200),
  contextChecksum: z.string().regex(/^[0-9a-f]{16}$/),
  entries: z.array(z.object({ target: z.string().min(1).max(300), sourceFields: z.array(LocalProducerSourceFieldSchema).min(1).max(10) }).strict()).min(1).max(150)
}).strict().superRefine((manifest, ctx) => {
  if (new Set(manifest.entries.map(entry => entry.target)).size !== manifest.entries.length || manifest.entries.some(entry => new Set(entry.sourceFields).size !== entry.sourceFields.length))
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Producer targets and source fields must be unique" });
});
export type LocalProducerSourceManifest = z.infer<typeof LocalProducerSourceManifestSchema>;
export type LocalProducerSourceField = z.infer<typeof LocalProducerSourceFieldSchema>;
